import { requestService as api } from "./Request.service"  
const API_URL = { 
  API_SALESCOST: `/report/sales-cost.php`, 
  SALESCOST: `/report/sales-cost-download.php`, 
};
  
const ReportService = () => { 

  const SalesCostDownload = (payload) => api({
      method: 'post',
      url: API_URL.SALESCOST,
      data: payload,
      responseType: 'blob', // Set responseType to 'blob' to handle binary data (like files)
    }).then(response => {  
      const blob = new Blob([response.data], { type: response.headers['content-type'] }); 
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', `รายงานยอดขายเปรียบเทียบต้นทุน.xlsx`);
      link.target = "_bank";
      document.body.appendChild(link);
      link.click();
       
      document.body.removeChild(link);
    });
  
  const SalesCost = (parm = {}) => api.post(`${API_URL.API_SALESCOST}`, parm);
  

  return {
    SalesCost,
    SalesCostDownload,
  };
};

export default ReportService;